module.exports = __webpack_public_path__ + "static/media/campaign-image.89438b7f.svg";